import { createPortal } from "react-dom";
import { Icon } from "../../icons";
import { TOAST_ICON, type ToastEntry, toastDuration, toastRole, toastTone } from "./toastModel";

interface ToastStackProps {
  toasts: ToastEntry[];
  onDismiss: (id: number) => void;
}

/** The live region at the corner of the page where toasts appear. */
export function ToastStack({ toasts, onDismiss }: ToastStackProps): React.JSX.Element {
  return createPortal(
    <div className="nb-toasts" aria-live="polite" aria-relevant="additions">
      {toasts.map((toast) => (
        <ToastCard key={toast.id} toast={toast} onDismiss={() => onDismiss(toast.id)} />
      ))}
    </div>,
    document.body,
  );
}

function ToastCard({ toast, onDismiss }: { toast: ToastEntry; onDismiss: () => void }): React.JSX.Element {
  const tone = toastTone(toast);
  return (
    <div className={`nb-toast nb-toast-${tone}${toast.leaving ? " is-leaving" : ""}`} role={toastRole(tone)}>
      <Icon name={TOAST_ICON[tone]} className="nb-toast-icon" />
      <div className="nb-toast-body">
        <strong>{toast.title}</strong>
        {toast.text ? <p>{toast.text}</p> : null}
      </div>
      <button type="button" className="nb-icon-btn nb-icon-btn-sm" aria-label="Dismiss notification" onClick={onDismiss}>
        <Icon name="x" />
      </button>
      <span className="nb-toast-bar" style={{ animationDuration: `${toastDuration(toast)}ms` }} />
    </div>
  );
}
